export const ACTIVE_STATE_CLASS = 'active';
export const DEFAULT_STATE_CLASS = 'default';

export const INDICATOR_POINTER_ASSET = '/assets/images/indicator_pointer.svg';
